import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
export const COPY_REF_TASK = "COPY_REF_TASK";

export const service = async (data) => {
  const options: object = {
    url: `/Api/RefTask/CopyRefTask?refTaskId=` + data.refTaskId,
    method: "POST",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(COPY_REF_TASK, service, mock);
